import { popinApi } from './api';

export const notificationApi = {
  getStatus: () => {
    return Promise.resolve().then(() => {
      return popinApi.get(`/notifications/status`);
    });
  },
  getList: () => {
    return Promise.resolve().then(() => {
      return popinApi.get(`/notifications/list`);
    });
  },
  clear: (id) => {
    return Promise.resolve().then(() => {
      return popinApi.put(`/notifications/clear`, { notification_id: id });
    });
  },
  clearUnseen: () => {
    return Promise.resolve().then(() => {
      return popinApi.put(`/notifications/clear`, { unseen_only: true });
    });
  }
};
